export interface ColorType {
  id: number;
  hexCode: string;
}
